import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { NavLink } from 'react-router-dom';
import { Menu, Badge, Icon } from 'antd';
import { withAsyncActions } from 'react-async-client';

import * as routes from 'constants/routes';
import { getNotifications } from 'actions/asyncActions';
import Breakpoint from './Breakpoint';


const { Item } = Menu;



function getOpenKey(pathname) {
    if (
        routes.configurator.catalog.match(pathname) ||
        routes.configurator.design.match(pathname)
    ) {
        return 'configurator';
    }
}

@withAsyncActions({
    getNotifications
})
class MainMenu extends Component {
    
    componentDidMount() {
        this.getNotifications();
        this.interval = setInterval(this.getNotifications, 7000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }


    
    getNotifications = () => {
        const {location, getNotifications} = this.props;
        if (routes.notifications.match(location.pathname)) return;
        getNotifications.dispatch();
    }
   
    

    render() {
        const openKey = getOpenKey(this.props.location.pathname);
        const notifications = this.props.getNotifications.data;
        let count = 0;
        
        if (notifications && notifications.length) {
            count = notifications.reduce((accum, i) => {
                if (i.read === 0) return accum + 1;
                return accum;
            }, 0);
        }
    
    
        return (
            <Menu
                className="main-menu main-menu_top"
                mode="inline"
                selectable={false}
                defaultOpenKeys={[openKey]}
                inlineIndent={16}
            >
                <Item key="projects">
                    <NavLink to={routes.projects.stringify()}>
                        <Breakpoint max="md">
                            <Icon type="profile" />
                        </Breakpoint>
                        Проекты
                    </NavLink>
                </Item>
                <Item key="products" >
                    <NavLink to={routes.products.path}>
                        <Breakpoint max="md">
                            <Icon type="dropbox" />
                        </Breakpoint>
                        Продукты
                    </NavLink>
                </Item>
                <Item key="notifications">
                    <NavLink to={routes.notifications.path}>
                        <Breakpoint max="md">
                            <Icon type="bell" />
                        </Breakpoint>
                        Уведомления <Badge count={count} overflowCount={99} />
                    </NavLink>
                </Item>
                
                <Item key="bonus">
                    <NavLink to={routes.bonus.path}>
                        <Breakpoint max="md">
                            <Icon type="gift" />
                        </Breakpoint>
                        Бонус
                    </NavLink>
                </Item>
                <Breakpoint min="md">
                    <div className="menu__call" onClick={this.props.toggleFeedbackModal}>
                        Обратная связь
                    </div>
                </Breakpoint>
                <Item key="profile" >
                    <NavLink to={routes.profile.path} exact>
                        <Breakpoint max="md">
                            <Icon type="user" />
                        </Breakpoint>
                        Профиль
                    </NavLink>
                </Item>
                <Breakpoint min="md">
                    <Item>
                        <a className="exit" onClick={this.props.logout}>
                            <Icon type="logout" /> Выйти
                        </a>
                    </Item>
                </Breakpoint>
            </Menu>
        );
    }
}

export default withRouter(MainMenu);



// WEBPACK FOOTER //
// ./src/components/layout/MainMenu.js